export const plans = {
  title: "Escolha seu plano",
  subtitle: "Preço por unidade e mês, com descontos por volume. Você pode combinar vários tipos de acomodação no mesmo pedido.",
  typeLabel: "Tipo de acomodação",
  types: {
    apartamento: "Apartamentos",
    hotel: "Hotel",
    camping: "Camping",
    villa: "Vilas",
  },
  units: {
    apartamento: "apartamento | apartamentos",
    hotel: "quarto | quartos",
    camping: "acomodação | acomodações",
    villa: "vila | vilas",
  },
  decrease: "Remover uma unidade",
  increase: "Adicionar uma unidade",
  billing: {
    label: "Faturamento",
    monthly: "Mensal",
    annual: "Anual",
    annualSave: "−20%",
  },
  perUnit: "/mês por unidade",
  totalLine: "{qty} {units} · {total}/mês no total",
  billedAnnually: "cobrado anualmente",
  add: "Adicionar ao pedido",
  isNew: "Novo",
  pro: {
    badge: "Mais popular",
    tagline: "Toda a plataforma: IA, canais, cobranças e receita.",
    f1: "Check-in online e fichas de hóspedes enviadas automaticamente às autoridades",
    f2: "Recepção IA 24/7 pelo WhatsApp: atende, tira dúvidas e automatiza",
    f3: "Caixa de entrada unificada (WhatsApp + Booking, Airbnb e Expedia), tradução e transferência para atendente humano",
    f4: "Faturamento eletrônico (nota fiscal eletrônica)",
    f5: "Channel Manager +100 OTAs, calendário unificado e gestão de preços (zero overbooking)",
    f6: "Reservas diretas com seu próprio site, sem comissões",
    f7: "Fechaduras inteligentes com códigos de acesso automáticos",
    f8: "Extras e upselling, estender estadia e promoções",
    f9: "Cobranças e pagamentos com antecipação",
    f10: "Limpeza e equipe, com funções e acessos",
    f11: "Multipropriedade, analytics e relatórios por proprietário",
  },
  suite: {
    badge: "Tudo incluído",
    tagline: "O plano mais completo: recepção telefônica com IA, seu próprio site e preços dinâmicos.",
    lead: "Tudo do Pro, e ainda:",
    s1: "Número próprio para WhatsApp e chamadas",
    s2: "Recepção IA por telefone: atende o telefone 24/7 no idioma do hóspede",
    s3: "Chamadas recebidas: 40 min/mês incluídos",
    s4: "WebBuilder: seu site completo",
    s5: "Preços dinâmicos: ajuste automático de tarifas",
    s6: "Múltiplas entidades de faturamento para associar a cada acomodação",
  },
  cart: {
    title: "Seu pedido",
    empty: "Escolha o tipo de acomodação e as unidades, e adicione um plano.",
    plan: "Plano {plan}",
    remove: "Remover",
    monthlyTotal: "Total por mês",
    annualTotal: "Cobrado por ano: {total}",
    planSwitched: "Um pedido tem um único plano: agora tudo é {plan}.",
    welcomeTitle: "Desconto de convite aplicado",
    welcomeMonthly: "{percent}% de desconto nos primeiros {months} meses: {total}/mês",
    welcomeAnnual: "Você economiza {amount} na primeira fatura anual",
    pay: "Continuar para o pagamento",
    paying: "Abrindo o pagamento…",
    taxes: "Impostos não incluídos. O Stripe vai pedir seus dados de faturamento.",
    error: "Não foi possível abrir o pagamento. Tente novamente.",
  },
  payment: {
    success: "Pagamento recebido. Seu plano será ativado em alguns segundos.",
    failed: "O pagamento não foi concluído. Você pode tentar novamente quando quiser.",
    active: "Pronto! Seu plano já está ativo.",
  },
  active: {
    includes: "O que seu plano inclui",
    discount: "Desconto de convite: {percent}% até {date}",
    discountAnnual: "Desconto de convite aplicado na sua primeira fatura",
    referralCredit: "Você tem {amount} de crédito por convidar outros anfitriões: ele será descontado da sua próxima fatura.",
  },
};
